import { render, staticRenderFns } from "./TempoParaSleepOneblock.vue?vue&type=template&id=ddcd1814"
import script from "./TempoParaSleepOneblock.vue?vue&type=script&lang=js"
export * from "./TempoParaSleepOneblock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports